/// <amd-module name="Search/Shared/Base/Stores/ZeroDataStore2" />

import * as VSSStore from "VSS/Reflux/Store";
import { ScenarioType } from "Search/Shared/Components/ZeroData/ZeroData.Props";
import { InfoCodes } from "Search/WebApi/Contracts/Search.Shared";
import { ISearchFailedPayload } from "Search/Shared/Base/ActionsHub2";
import { EntitySearchRequest } from "Search/WebApi/Contracts/Search.Shared";

export interface ZeroDataState {
    scenario: ScenarioType;
}

export class ZeroDataStore extends VSSStore.Store {
    protected _state: ZeroDataState = { scenario: ScenarioType.None } as ZeroDataState;

    public get state(): ZeroDataState {
        return this._state;
    }

    public onSearchFailed = (
        payload: ISearchFailedPayload<EntitySearchRequest>,
        query: EntitySearchRequest): void => {
        if (this.areQueriesSame(payload.query, query)) {
            this._state.scenario = ScenarioType.ServiceError;
            this.emitChanged();
        }
    }

    public onLandingPage = (): void => {
        this._state.scenario = ScenarioType.LandingPage;
        this.emitChanged();
    }

    public reset = (): void => {
        this._state.scenario = ScenarioType.None;
        this.emitChanged();
    }

    /**
    * Return the results after comparing the queries.
    * @param queryInState
    * @param queryInPayload
    */
    protected areQueriesSame(
        queryInState: EntitySearchRequest,
        queryInPayload: EntitySearchRequest): boolean {
        return true;
    }
}

export function getScenario(
    infoCode: InfoCodes,
    totalResultsCount: number,
    showMoreScenario: boolean): ScenarioType {
    const scenarioType: ScenarioType | undefined = getScenarioTypeFromInfoCode(infoCode);
    if (scenarioType === undefined) {
        if (totalResultsCount <= 0) {
            return ScenarioType.ZeroResults;
        }
        else {
            return !showMoreScenario
                ? ScenarioType.NoPermissionWithShowMore
                : ScenarioType.NoPermissionAfterShowMore;
        }
    }

    return scenarioType as ScenarioType;
}

function getScenarioTypeFromInfoCode(infoCode: InfoCodes): ScenarioType | undefined {
    switch (infoCode) {
        case InfoCodes.AccountIsBeingOnboarded:
        case InfoCodes.AccountIsBeingReindexed:
            return ScenarioType.IndexingScenario;

        case InfoCodes.PrefixWildcardQueryNotSupported:
            return ScenarioType.PrefixWildCardNotSupported;

        case InfoCodes.WorkItemsNotAccessible:
            return ScenarioType.NoPermission;

        case InfoCodes.EmptyQueryNotSupported:
            return ScenarioType.EmptyQueryNotSupported;

        case InfoCodes.OnlyWildcardQueryNotSupported:
            return ScenarioType.OnlyWildcardQueryNotSupported;

        case InfoCodes.ZeroResultsWithWildcard:
            return ScenarioType.ZeroResultsWithWildcard;

        case InfoCodes.ZeroResultsWithFilter:
            return ScenarioType.ZeroResultsWithFilter;

        case InfoCodes.ZeroResultsWithWildcardAndFilter:
            return ScenarioType.ZeroResultsWithWildcardAndFilter;

        case InfoCodes.ZeroResultsWithNoWildcardNoFilter:
            return ScenarioType.ZeroResultsWithNoWildcardNoFilter;

        case InfoCodes.MultiWordWithCodeFacetNotSupported:
        // ToDo

        default:
            return undefined;
    }
}